import i18n from '@/locale'
import timer from './timer'

/**
 * 延迟执行
 * @param {*} duration
 * @returns Promise
 */
export function delay(duration = 4) {
  return new Promise((resolve) => {
    setTimeout(resolve, duration)
  })
}
/**
 * 下载文件
 * @param {Blob} blob
 */
export function downloadFile(blob) {
  const a = document.createElement('a')
  a.download = decodeURI(blob.headers['content-disposition'].split("''")[1])
  a.style.display = 'none'
  a.href = URL.createObjectURL(blob.data)
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(a.href)
  document.body.removeChild(a)
}
/**
 * 创建计时器函数
 * @param { String } name 计时器名称
 * @param { Function } func 计时器执行函数
 * @param { Number } time 计时器间隔
 */
export function actionTimer(name, func, time) {
  timer.clearTimer(name)
  timer.createTimer(
    name,
    () => {
      func()
    },
    time
  )
}
/**
 * 将map对象的key-value 转成下拉选项{label,value}
 * @param {*} map
 * @returns
 */
export function mapToOptions(map) {
  return Object.keys(map).map((key) => ({
    label: map[key],
    value: key,
  }))
}

/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n)
}
/**
 * @description //语音播报专用，因为语音播报无法读出.以及小数点后两位处理
 * @param num
 * @returns {number}
 */
export function convertMoney(num) {
  const str = num.toString()
  const [integerPart, decimalPart] = str.split('.')

  if (decimalPart && decimalPart.length === 2) {
    return i18n.t('{integerPart}点{slot1} {slot2}', {
      integerPart: integerPart,
      slot1: decimalPart[0],
      slot2: decimalPart[1],
    })
  }
  if (decimalPart && decimalPart.length === 1) {
    return i18n.t('{integerPart}点{slot1}', { integerPart: integerPart, slot1: decimalPart[0] })
  }
  return str // 如果没有两位，则原样返回
}
/**
 * 判断是否是android环境
 * @returns
 */
export const isAndroid = /MGCR/i.test(navigator.userAgent)
/**
 * 发送webfunny事件
 * @param {*} eventCode
 * @param {*} eventData
 */
export function sendWebFunnyEvent(eventCode, eventData) {
  if (eventData.actionType === void 0) eventData.actionType = '页面跳转'
  if (eventData.stayTime === void 0) eventData.stayTime = -1
  if (eventData.caiDan === void 0) eventData.caiDan = document.title.split('●')[1]
  window.webfunnyEvent(eventCode).trackEvent({
    ...eventData,
    jinRuShiJian: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    pageUrl: window.location.pathname,
  })
}

// 加密会员名称
export function encryptMemberName(name) {
  if (typeof name !== 'string' || name.trim() === '') return ''
  const trimmedName = name.trim()
  // 常见复姓列表
  const compoundSurnames = [
    '欧阳',
    '上官',
    '司徒',
    '司马',
    '诸葛',
    '夏侯',
    '宇文',
    '公孙',
    '慕容',
    '端木',
    '东方',
    '尉迟',
    '皇甫',
    '澹台',
    '公冶',
    '申屠',
    '令狐',
    '钟离',
    '长孙',
    '轩辕',
    '鲜于',
    '闾丘',
    '亓官',
    '司寇',
    '巫马',
    '公西',
    '颛孙',
  ]

  // 尝试匹配复姓
  const firstTwoChars = trimmedName.slice(0, 2)
  if (compoundSurnames.includes(firstTwoChars)) {
    return firstTwoChars + '*'.repeat(trimmedName.length - 2)
  }

  // 单姓处理
  return trimmedName.charAt(0) + '*'.repeat(trimmedName.length - 1)

}

/**
 * 延迟执行
 * @param {*} duration
 * @returns
 */
export function sleep(duration = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, duration)
  })
}
